module.exports = __webpack_public_path__ + "static/img/8.0e2a039.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/3/zh/8.png
// module id = mrnt
// module chunks = 0